import { type ReactNode } from 'react';

import styles from '@web/molecules/SimpleComment/SimpleComment.module.scss';

export interface Props {
    metaIcon: ReactNode;
    metaSuffix: string;
    count: number;
}

export const CommentMeta = ({ metaIcon, metaSuffix, count }: Props) => (
    <div className={styles['meta']}>
        {metaIcon ? metaIcon : ''}
        <span>
            {count ? count.toString() : '0'} {metaSuffix ? metaSuffix : ''}
        </span>
    </div>
);
